import { render, staticRenderFns } from "./GroupShareModal.vue?vue&type=template&id=29407810"
import script from "./GroupShareModal.vue?vue&type=script&lang=js"
export * from "./GroupShareModal.vue?vue&type=script&lang=js"
import style0 from "./GroupShareModal.vue?vue&type=style&index=0&id=29407810&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports